var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-box"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-count":_vm.totalPage,"page-size":_vm.limit},on:{"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }